module.exports = __webpack_public_path__ + "89508314597c76deca4bbc32d608a7be.svg";